import {
  appVersionDtoSchema as appVersionSchema,
  type AppVersionDto as AppVersion,
} from '@lib/dto/app-version.dto'

/**
 * True when the SHA served at `/version.json` differs from the SHA this
 * tab captured on first load — i.e. a newer frontend has been deployed.
 */
export function isNewerDeploy(
  runningSha: string | null,
  deployedSha: string | null,
): boolean {
  if (runningSha == null || deployedSha == null) return false
  if (runningSha.length === 0 || deployedSha.length === 0) return false
  return runningSha !== deployedSha
}

/**
 * Fetch the currently served frontend version. Cache-busted so CDNs / `serve`
 * cannot hide a just-deployed SHA. Returns `null` when the file is missing
 * or invalid (old deploys, local preview without the plugin).
 */
export async function fetchDeployedVersion(): Promise<AppVersion | null> {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      cache: 'no-store',
    })
    if (!response.ok) return null
    const parsed = appVersionSchema.safeParse(await response.json())
    return parsed.success ? parsed.data : null
  } catch {
    return null
  }
}
